module.exports = __webpack_public_path__ + "img/table_noData.ff561e23.png";